import clsx from 'clsx';
import { MerchantCurrency } from '../MerchantCurrency';
import Typography from 'components/Typography/Typography';

import styles from './LineItemLayout.module.scss';
import { Icon } from '../Icon';
import { HTMLAttributes, MouseEventHandler } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { LINE_ITEM_TEST_ID } from './LineItems.const';

type DiscountInfo = {
  name: string;
  amount?: number;
}

type LineItemLayoutProps = {
  name: string;
  price: number;
  discounts?: DiscountInfo[];
  onRemove?: MouseEventHandler<Element>;
  available?: boolean;
}

export const LineItemLayout: React.FC<HTMLAttributes<HTMLDivElement> & LineItemLayoutProps> = ({ name, onRemove, price, children, discounts = [], available = true, ...props }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.layout} {...props}>
      <dl className={styles.description} data-testid={LINE_ITEM_TEST_ID.item}>
        <dt className={clsx(available ? styles.item : styles.disabled)}>{name}</dt>
        { available && <MerchantCurrency tagName="dd" amount={price} className={clsx(styles.bold, styles.price)} /> }
        { !available && <dd><Typography.Body bold>{t('cart.unavailable')}</Typography.Body></dd> }
      </dl>
      {discounts.length > 0 && discounts.map(({ name: discountName, amount }, index) => (
          <dl key={index} className={clsx(styles.description, styles.discount)}>
            <dt data-testid={LINE_ITEM_TEST_ID.discountName}>{discountName}</dt>
            <dd data-testid={LINE_ITEM_TEST_ID.discountAmount}>
              <Trans i18nKey="perks.discountWrapper">
                  (<MerchantCurrency amount={amount} />)
              </Trans>
            </dd>
          </dl>
        ))}
      <div className={styles.container}>
        <div className={styles.content}>
          {children}
        </div>
        {onRemove &&
          <button
            type="button"
            title={t('cart.item.remove')}
            className={styles.removeButton}
            aria-label={`${t('cart.item.remove')}: ${name}`}
            onClick={onRemove}
            data-testid={LINE_ITEM_TEST_ID.remove}>
            <Icon name="bin" size={16} />
          </button>}
      </div>
    </div>
  );
};
